import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

function getConfig() {
  const MASTER_BRANCH = 'master'
  const LEGACY_BRANCH = 'legacy'
  const DEV_BRANCH = 'develop'
  const E_CATERING_BRANCH = 'eCateringPanel'
  const FIX_MASTER_BRANCH = 'fix-master'

  // @ts-expect-error
  const isProduction = import.meta.env.VITE_CI_COMMIT_REF_NAME === MASTER_BRANCH || import.meta.env.VITE_CI_COMMIT_REF_NAME === LEGACY_BRANCH || import.meta.env.VITE_CI_COMMIT_REF_NAME === DEV_BRANCH || import.meta.env.VITE_CI_COMMIT_REF_NAME === E_CATERING_BRANCH || import.meta.env.VITE_CI_COMMIT_REF_NAME === FIX_MASTER_BRANCH

  if (isProduction) {
    return {
    // @ts-expect-error checked
      apiKey: import.meta.env.VITE_API_KEY,
      // @ts-expect-error checked
      appId: import.meta.env.VITE_APP_ID,
      // @ts-expect-error checked
      authDomain: import.meta.env.VITE_AUTH_DOMAIN,
      // @ts-expect-error checked
      measurementId: import.meta.env.VITE_MEASUREMENT_ID,
      // @ts-expect-error checked
      messagingSenderId: import.meta.env.VITE_MESSAGING_SEND_ID,
      // @ts-expect-error checked
      projectId: import.meta.env.VITE_PROJECT_ID,
      // @ts-expect-error checked
      storageBucket: import.meta.env.VITE_STORAGE_BUCKET,
    }
  }

  return {
    // @ts-expect-error checked
    apiKey: import.meta.env.VITE_STAGING_API_KEY,
    // @ts-expect-error checked
    appId: import.meta.env.VITE_STAGING_APP_ID,
    // @ts-expect-error checked
    authDomain: import.meta.env.VITE_STAGING_AUTH_DOMAIN,
    // @ts-expect-error checked
    measurementId: import.meta.env.VITE_STAGING_MEASUREMENT_ID,
    // @ts-expect-error checked
    messagingSenderId: import.meta.env.VITE_STAGING_MESSAGING_SEND_ID,
    // @ts-expect-error checked
    projectId: import.meta.env.VITE_STAGING_PROJECT_ID,
    // @ts-expect-error checked
    storageBucket: import.meta.env.VITE_STAGING_STORAGE_BUCKET,
  }
}

export const config = getConfig()
export const app = initializeApp(config)
export const auth = getAuth(app)
export const firestore = getFirestore(app)
export const storage = getStorage(app)
export const secondaryFirebaseApp = initializeApp(config, 'primary')
